import { useEffect, useState } from 'react'
import { ShieldCheck, X } from 'lucide-react'
import { getAnalyticsConsent, initializeAnalytics, setAnalyticsConsent } from '../../services/analytics'

export const OPEN_PRIVACY_EVENT = 'omikina:open-privacy-controls'

export function PrivacyControls() {
  const [open, setOpen] = useState(() => getAnalyticsConsent() === 'unset')
  useEffect(() => {
    initializeAnalytics()
    const show = () => setOpen(true)
    window.addEventListener(OPEN_PRIVACY_EVENT, show)
    return () => window.removeEventListener(OPEN_PRIVACY_EVENT, show)
  }, [])
  if (!open) return null
  const choose = (choice: 'granted' | 'denied') => { setAnalyticsConsent(choice); setOpen(false) }
  return <aside className="privacy-controls" aria-label="Privacy choices">
    <ShieldCheck aria-hidden="true"/>
    <div><strong>YOUR READING. YOUR CHOICE.</strong><p>OMIKINA uses optional Google Analytics to understand which public pages help readers. Saved stories and topic choices stay in this browser. This choice does not enable advertising.</p><a href="/privacy">Read the privacy notice</a></div>
    <div className="privacy-controls-actions"><button onClick={() => choose('denied')}>ESSENTIAL ONLY</button><button onClick={() => choose('granted')}>ALLOW ANALYTICS</button></div>
    {getAnalyticsConsent() !== 'unset' && <button className="privacy-controls-close" onClick={() => setOpen(false)} aria-label="Close privacy choices"><X/></button>}
  </aside>
}
